import React from 'react';
import ContentManagement from './ContentManagement';

const HomeContent = () => {
  return <ContentManagement page="home" />;
};

export default HomeContent;
